module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-5-1500x630.af1a5252.jpg";